<script>
    import CardSelector from "./cardSelector.svelte";
    import CardSlide from "./cardSlide.svelte";
let  itemSelected='';
import { fly } from "svelte/transition"
let isactive=false;
</script>


<div><CardSelector bind:itemSelected /></div>
<div in:fly="{{ y: 200, duration: 2000 }}">
    <CardSlide bind:itemSelected 
/>
</div>

<style>
   
</style>